import React from 'react';
import FormControl from 'react-bootstrap/FormControl';
import Select from 'react-select';

import CountryCodes from '../../util/CountryCode';
import RegEx from '../../util/RegEx';
import Display from '../../util/Display';
import Const from '../../util/Constants';

class FieldMultiPhoneItem extends React.Component {

  static Phone = 'phone';
  static Code = 'code';

  constructor(props) {
    super(props);
    this.regex = props.validate;
    const value = props.value !== '' && props.value ?
      props.value.split(Const.Hhn) : [ props.code, '' ];
    const code = CountryCodes.find(code => code.value === value[0]);
    this.state = { code: code, value: value[1] };
  }

  handleChange = (field, val) => {
    if(field === FieldMultiPhoneItem.Phone)
      this.setState({ ...this.state, value: val});
    else if(field === FieldMultiPhoneItem.Code)
      this.setState({...this.state, code: val });
    
    if(field === FieldMultiPhoneItem.Phone) //&& RegEx.isPhone(val, this.regex))
      this.props.onChange(this.props.index, `${this.state.code.value}-${val}`);
    else if(field === FieldMultiPhoneItem.Code)
      this.props.onChange(this.props.index, `${val.value}-${this.state.value}`); 
  }

  render() {
    let inValid = this.state.value === '' || RegEx.isPhone(this.state.value, this.regex);
    if(RegEx.isKeyPresent(this.props.inValid, this.Key)) inValid = false;

    return (
      <div className="form-group">
        <div className="phone-code">  
          <Select value={this.state.code} options={CountryCodes} isSearchable={true}
            onChange={seletced => this.handleChange(FieldMultiPhoneItem.Code, seletced)} />
          <FormControl type="text" value={this.state.value} placeholder="Phone"
            onChange={evt => this.handleChange(FieldMultiPhoneItem.Phone, evt.target.value)}
            className={`mr-sm-2 ${RegEx.classBool(inValid)}`} />
        </div>
        { Display.MultiAction(this.props.index, this.props.add, this.props.delete) }
      </div>
    );
  }
}
export default FieldMultiPhoneItem;